var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoubleArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29652 11.3005C4.10225 11.4767 4 11.7358 4 11.9948C4 12.2642 4.10225 12.5026 4.29652 12.6995L12.3947 20.7202C12.5787 20.8964 12.8037 21 13.0593 21C13.591 21 14 20.5959 14 20.057C14 19.7876 13.8978 19.5492 13.7342 19.3834L6.29039 11.9948L13.7342 4.61658C13.8978 4.44041 14 4.20207 14 3.943C14 3.40414 13.591 3 13.0593 3C12.8037 3 12.5787 3.10363 12.4049 3.27979L4.29652 11.3005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2965 11.3005C10.1023 11.4767 10 11.7358 10 11.9948C10 12.2642 10.1023 12.5026 10.2965 12.6995L18.3947 20.7202C18.5787 20.8964 18.8037 21 19.0593 21C19.591 21 20 20.5959 20 20.057C20 19.7876 19.8978 19.5492 19.7342 19.3834L12.2904 11.9948L19.7342 4.61658C19.8978 4.44041 20 4.20207 20 3.943C20 3.40414 19.591 3 19.0593 3C18.8037 3 18.5787 3.10363 18.4049 3.27979L10.2965 11.3005Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoubleArrowLeft);
export default __webpack_public_path__ + "static/media/icon-double-arrow-left.c1e81068a0286a5a8955e98d63cce3c1.svg";
export { ForwardRef as ReactComponent };